import axios from 'axios';

export declare type ParsedOrgContractType = {
  _id: string;
  contractRateLabel: string;
  contractNumber: string;
  contractStartDate: string;
  contractEndDate: string;
  pricingEffectiveDate: string;
  pricingEndDate: string;
  rate: string;
  ratingMethodType: 'One Time Charge' | 'Subscription' | 'Usage';
  profileBillingCycle: string;
  productBillingModel: string;
};

const getOrgContracts = async ({
  mlsStaffOrgId,
}: {
  mlsStaffOrgId: string;
}) => {
  try {
    const { data } = await axios.get<ParsedOrgContractType[]>(
      `/supra/org_contracts/${mlsStaffOrgId}`,
    );
    return data;
  } catch (error: any) {
    // Check for 404 error and return an empty array
    if (error.response && error.response.status === 404) {
      return [];
    }
    throw error;
  }
};

export default getOrgContracts;
